<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Attach Document: {{ dialogTitle }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="dialog-content">
  <div class="divModalContent form-container">
    <div class="mandatory-info">
      <span class="appLabelText">(<span>*</span>) Marked fields are Mandatory</span>
    </div>
    <form #attachDocForm="ngForm" id="loadSlipForm">
      <input type="hidden" [(ngModel)]="loadScheduleId" name="fsid">
      <input type="hidden" [(ngModel)]="screenTypeId" name="screenTypeId">

      <div class="form-field-group">
        <div>
          <mat-form-field appearance="outline" class="form-field-item small full-width-field" style="width:100%">
            <mat-label>Document Type<span style="color: red"></span></mat-label>
            <mat-select [(ngModel)]="docTypeId" name="docTypeId" data-testid="docTypeId" required
                        (selectionChange)="onDocTypeChange()" #docTypeInput="ngModel">
              <mat-option [value]=null>- Select DocType -</mat-option>
              @for (docType of docTypes; track trackById(docType.id, docType)) {
              <mat-option [value]="docType.id">{{ docType.docType }}</mat-option>
              }
            </mat-select>
            <mat-error *ngIf="docTypeInput.invalid && (docTypeInput.dirty || docTypeInput.touched)">
              Document type is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex flex-col gap-2 drop-zone-wrapper">
          <mat-label class="text-base font-medium text-gray-700">Attach Document(s)<span>*</span></mat-label>
          <div class="drop-zone"
               (click)="fileInput.click()"
               (dragover)="onDragOver($event)"
               (drop)="onDrop($event)">
            <p class="drop-text">
              Drag & Drop files here or click to select
            </p>

            <button type="button" class="choose-btn">
              Choose Files
            </button>

            <span class="file-info">
              {{
              (selectedFiles && selectedFiles.length > 0)
              ? (selectedFiles.length + ' file(s) selected')
              : 'No file chosen'
              }}
            </span>

            <input type="file" #fileInput hidden class="file-input-hidden" ngModel multiple name="loadSlipFiles"
                   (change)="onFileSelected($event)" />
          </div>

          <div *ngIf="attachDocForm.controls['loadSlipFiles']?.invalid && (attachDocForm.controls['loadSlipFiles']?.dirty || attachDocForm.controls['loadSlipFiles']?.touched)"
               class="text-red-500 text-xs">
            <div *ngIf="attachDocForm.controls['loadSlipFiles']?.errors?.['required']" style="color:red;">
              A document is required.
            </div>
            <div *ngIf="attachDocForm.controls['loadSlipFiles']?.errors?.['invalidFileType']">
              Only .jpg, .jpeg, .png, .bmp, .gif, .pdf files are allowed.
            </div>
          </div>
        </div>
      </div>

      <table class="doc-table" *ngIf="documents.length > 0" style="margin-bottom:10px">
        <thead>
          <tr>
            <th class="col-doc">Document Type</th>
            <th class="col-file">File</th>
            <th class="col-action">Action</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let doc of documents">

            <tr *ngFor="let file of doc.files">

              <!-- Doc Type -->
              <td class="col-doc">
                {{ doc.docTypeName }}
              </td>

              <!-- File -->
              <td class="col-file">
                <a (click)="downloadFile(file)" class="download-link">
                  {{ file.name }}
                </a>
              </td>

              <!-- Action -->
              <td class="col-action">
                <button mat-icon-button color="warn" (click)="removeFile(doc.docTypeId, file)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>

            </tr>

          </ng-container>
        </tbody>
      </table>

      <div class="empty-state" *ngIf="documents.length === 0">
        No documents uploaded
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary (click)="onClose()">
    Close
  </button>
  <button mat-raised-button color="primary" mat-primary data-testid="btnUploadDoc" id="btnUploadDoc"
          (click)="onUploadDocument()">
    Upload
  </button>
</mat-dialog-actions>
